// extracted by mini-css-extract-plugin
export var card = "_96-1";
export var container = "_96-0";